export default __webpack_public_path__ + "cb88cb3ae0bf07ec7571bd5ccc5f257d.wav";